module.exports = __webpack_public_path__ + "static/media/background-blurred.998f280d.jpg";